import { ReactElement } from 'react';
import SkyhopPdfFooter from '@/features/PdfLayout/components/SkyhopPdfFooter';

// Static office contact from the design; the training report response carries no company data (unlike Invoice)
const TrainingReportPdfFooter = (): ReactElement => (
  <SkyhopPdfFooter title="Office Contact">
    <SkyhopPdfFooter.Section>
      <SkyhopPdfFooter.SectionHeader>Office Address</SkyhopPdfFooter.SectionHeader>
      <SkyhopPdfFooter.Item>1150 Lee Wagner Blvd Suite 100</SkyhopPdfFooter.Item>
      <SkyhopPdfFooter.Item>Fort Lauderdale, Fl</SkyhopPdfFooter.Item>
      <SkyhopPdfFooter.Item>United States, 33315</SkyhopPdfFooter.Item>
    </SkyhopPdfFooter.Section>
    <SkyhopPdfFooter.Section>
      <SkyhopPdfFooter.SectionHeader>Phone</SkyhopPdfFooter.SectionHeader>
      <SkyhopPdfFooter.Item>Accounting Dept:</SkyhopPdfFooter.Item>
      <SkyhopPdfFooter.Item>(541) 915-4534</SkyhopPdfFooter.Item>
    </SkyhopPdfFooter.Section>
    <SkyhopPdfFooter.Section>
      <SkyhopPdfFooter.SectionHeader>Web</SkyhopPdfFooter.SectionHeader>
      <SkyhopPdfFooter.Item>www.skyhopglobal.com</SkyhopPdfFooter.Item>
      <SkyhopPdfFooter.Item>billing@skyhopglobal.com</SkyhopPdfFooter.Item>
    </SkyhopPdfFooter.Section>
  </SkyhopPdfFooter>
);

export default TrainingReportPdfFooter;
